import { type ServiceMethod } from '@/application/interfaces/service';

import { type OrderData } from '../model';

export interface Response {
  data: OrderData;
}

export type Params = {
  orderId: string;
};

const getOrderById: ServiceMethod<Response, Params> =
  (httpClient) => async (data, options) => {
    const { orderId } = data;

    const { body } = await httpClient.get<Response, Params>(
      '/api/v3/sale-order/{orderId}',
      {
        ...options,
        params: {
          orderId,
        },
      }
    );

    return body;
  };

export default getOrderById;
